import { render, staticRenderFns } from "./BuildingInfor.vue?vue&type=template&id=ab3b5460&scoped=true"
import script from "./BuildingInfor.vue?vue&type=script&lang=js"
export * from "./BuildingInfor.vue?vue&type=script&lang=js"
import style0 from "./BuildingInfor.vue?vue&type=style&index=0&id=ab3b5460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3b5460",
  null
  
)

export default component.exports